import BaseView from "./_BaseView";
import Table from "../components/Table";

export default class OrganizationSingleView extends BaseView {
    init() {
        super.init();

        const org = $('[data-org]').data('org');

        if ($('#orgSegment').length > 0) {
            this.segmentTable = new Table('orgSegment', `/api/organizations/${org}/segmenttable`, [
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'apps', orderable: false},
                {data: 'pathways', orderable: false},
                {data: 'guides', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#deployedGuides').length > 0) {
            this.guideTable = new Table('deployedGuides', `/api/organizations/${org}/deployedtable`, [
                {data: 'segment'},
                {data: 'app'},
                {data: 'title'},
                {data: 'desc'},
                {data: 'hidden'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'roles', orderable: false},
            ]);
        }

        if ($('#clonedGuides').length > 0) {
            this.guideTable = new Table('clonedGuides', `/api/organizations/${org}/guidetable?cloned=1`, [
                {data: 'ancestor'},
                {data: 'app'},
                {data: 'title'},
                {data: 'desc'},
                {data: 'hidden'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'roles', orderable: false},
            ]);
        }

        if ($('#originalGuides').length > 0) {
            this.guideTable = new Table('originalGuides', `/api/organizations/${org}/guidetable`, [
                {data: 'app'},
                {data: 'title'},
                {data: 'desc'},
                {data: 'hidden'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'roles', orderable: false},
            ]);
        }
    }

    setEvents() {
        super.setEvents();
    }
}